import type { Profile } from "../profile.ts"
import type { Route } from "./+types/layout.tsx"

import { Res } from "@iyk/vf-server"
import { Footer } from "@iyk/vf-ui"
import { Effect } from "effect"
import { Outlet } from "react-router"
import { appConfig } from "../../app-config.ts"
import { useLang } from "../../react-router/use-lang.ts"
import { Handler } from "../../server/handler.ts"
import { Header } from "../ui/header.tsx"
import stylesheet from "../ui/profile.css?url"
import { FanLayout } from "../../ui/fan-layout.tsx"

export const meta: Route.MetaFunction = () => [
  {
    title: `Profile | ${appConfig.artist.name}`
  },
  {
    property: "og:title",
    content: `Profile | ${appConfig.artist.name}`
  }
]

export const links: Route.LinksFunction = () => [{ rel: "stylesheet", href: stylesheet }]

type LoaderData = {
  user?: Profile.User
}

export const loader = Handler.make<LoaderData>("profile-layout", ({ api, sessions }) => {
  return sessions.authenticated.pipe(
    Effect.flatMap((session) => api.profile(session.user)),
    Effect.orElseSucceed(() => undefined),
    Effect.map((user) => Res.json({ user }))
  )
})

export default function ProfileLayout(props: Route.ComponentProps) {
  const lang = useLang()
  return (
    <FanLayout
      header={<Header user={props.loaderData.user} />}
      footer={<Footer social={appConfig.socialLinks} lang={lang} />}
      className="[&_header]:mb-2"
    >
      <Outlet />
    </FanLayout>
  )
}
